/**
 * hooks/hooks.ts — механизм диспетчеризации хуков (tech/21 §5/§9, D14).
 *
 * M2 даёт МЕХАНИЗМ: сбор подписчиков события + вызов в каноническом порядке
 * (по ячейке, затем ЧИСЛОВОЙ seq — D26/R13). Реестра карт ещё нет (M3a),
 * поэтому здесь ТЕСТ-ШОВ S7: синтетический хук подписывается на тип события
 * напрямую (без defineCard). В M3a сбор подписчиков переедет на реестр
 * (defId → CardHooks), а канонический порядок и дренаж останутся этими же.
 *
 * Хук ИМПЕРАТИВЕН: сам зовёт ctx.ops.* (ничего не возвращает); его реакции
 * попадают в очередь и обрабатываются дренажем, НЕ вложенно (R1).
 */
import { compareCellIds, parseCellId } from '../state/board.js';
import { assertInteger } from '../state/num.js';
/**
 * Канонический порядок по РАЗМЕЩЕНИЮ (tech/21 §9, tech/23 §4):
 * (tableId ASC, laneIndex ASC, side 'A' < 'B'), затем ЧИСЛОВОЙ seq;
 * сущности без ячейки — после всех с ячейкой, между собой по seq.
 * Единый компаратор для тест-шва подписок (M2) и диспетчеризации из реестра (M3a).
 */
export function compareByCanonicalPlacement(a, b) {
    const aHasCell = a.cellId !== undefined;
    const bHasCell = b.cellId !== undefined;
    if (aHasCell && bHasCell) {
        const byCell = compareCellIds(a.cellId, b.cellId);
        if (byCell !== 0)
            return byCell;
    }
    else if (aHasCell !== bHasCell) {
        return aHasCell ? -1 : 1;
    }
    return a.seq - b.seq;
}
/** Канонический порядок подписчиков одного события (см. compareByCanonicalPlacement). */
export function compareHookSubscriptions(a, b) {
    return compareByCanonicalPlacement(a, b);
}
/**
 * Транзиентный реестр подписок (как и очередь — НЕ сериализуется, не в
 * GameState). В M3a источником подписок станет реестр карт.
 */
export class HookRegistry {
    subs = [];
    /** Подписать хук; возвращает функцию отписки. */
    subscribe(sub) {
        assertInteger(sub.seq, 'HookRegistry.subscribe: seq');
        if (sub.cellId !== undefined) {
            parseCellId(sub.cellId); // валидация каноничности cellId (бросает понятно)
        }
        const stored = { ...sub };
        this.subs.push(stored);
        return () => {
            const i = this.subs.indexOf(stored);
            if (i >= 0) {
                this.subs.splice(i, 1);
            }
        };
    }
    /** Подписчики события в каноническом порядке (снапшот на момент вызова). */
    collect(event) {
        return this.subs
            .filter((s) => s.on === '*' || s.on === event.type)
            .sort(compareHookSubscriptions);
    }
    get size() {
        return this.subs.length;
    }
}
//# sourceMappingURL=hooks.js.map